/**
 * Starts a request on each call and returns its check: true until a later
 * request starts, so a response that a newer one has overtaken can be dropped.
 */
export function latestRequest() {
  let latest = 0;
  return () => {
    const id = ++latest;
    return () => id === latest;
  };
}
